import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

const styles = {
    label: {
        float: 'right',
    },
    input: {
        width: '100%',
    },
    row: {
        marginBottom: '10px',
    },
};

export class ProductMetaInfoModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props.meta_info,
        };
    }

    handleFieldValueChange = (e, fieldName) => {
        e.preventDefault();
        this.setState({
            [fieldName]: e.target.value,
        });
    }

    handleSaveButtonClick = (e) => {
        e.preventDefault();
        this.props.handleProductMetaInfoSave(this.state);
    }

    render() {
        return (
            <div>
                <Panel>
                    <Row style={styles.row}>
                        <Col xs={2}>
                            <label style={styles.label}><Translate value="meta_title" />:</label>
                        </Col>
                        <Col xs={6}>
                            <input maxLength="100" style={styles.input} type="text" value={this.state.meta_title} onChange={(e) => this.handleFieldValueChange(e, 'meta_title')} />
                        </Col>
                    </Row>
                    <Row style={styles.row}>
                        <Col xs={2}>
                            <label style={styles.label}><Translate value="meta_keywords" />:</label>
                        </Col>
                        <Col xs={9}>
                            <input maxLength="100" style={styles.input} type="text" value={this.state.meta_keywords} onChange={(e) => this.handleFieldValueChange(e, 'meta_keywords')} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={2}>
                            <label style={styles.label}><Translate value="meta_description" />:</label>
                        </Col>
                        <Col xs={9}>
                            <textarea rows={3} maxLength="500" style={styles.input} type="text" value={this.state.meta_description} onChange={(e) => this.handleFieldValueChange(e, 'meta_description')} />
                        </Col>
                    </Row>
                </Panel>
                <Button
                    bsStyle="success"
                    className="buttonStyle"
                    onClick={(event) => { this.handleSaveButtonClick(event); }}
                    style={{ float: 'right' }}
                >
                    <em className="fa fa-check" /><Translate value="confirm" />
                </Button>
            </div>
        );
    }
}

export default ProductMetaInfoModal


// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/ProductMetaInfoModal.jsx